import { Stack } from '@axo/ui-core/components/layout/item';
import { useEffect, useRef } from 'react';
import styles from '../../../loan.module.scss';
import { EmploymentFormGroup } from '../../shared/EmploymentFormGroup';
import { CoApplicantDetails } from './CoApplicantDetails';
import { CoApplicantHousing } from './CoApplicantHousing';

export const CoAppFormGroup = () => {
  const coAppRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (window?.location.hash === '#co-applicant' && coAppRef.current) {
      timeout = setTimeout(() => {
        coAppRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      id="co-applicant"
      ref={coAppRef}
      className={styles.inputGroup}
      data-grey={true}
    >
      <Stack gap="3xs">
        <CoApplicantDetails />
        <CoApplicantHousing />
        <EmploymentFormGroup applicant="CoApplicant" />
      </Stack>
    </div>
  );
};
